import { useContext } from 'react';
import { VirtualSlotsPlaceholderHighlightContext } from '../slotsPlaceholderContext';
import { isSlotHighlighted } from '../utils/extractSlotPreviewState';
export const useSlotHighlighting = (slotId) => {
    const highlightData = useContext(VirtualSlotsPlaceholderHighlightContext);
    return isSlotHighlighted(highlightData, slotId);
};
//# sourceMappingURL=useSlotHighlighting.js.map